export default "__VITE_ASSET__2d7bd392__"